import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';

import { getTesters } from './graphql';
import { Icon } from './styles';

import { annualHouseholdIncomeOptions } from '../../../tester/pages/sign-up-survey/options';
import { joinArrayItems } from '../../../core/utils/format-array';

const householdIncomeKeys = _.map(annualHouseholdIncomeOptions, 'key');

const buildHouseholdIncomeEnums = () => {
  const enums = { '-': 0 };

  _.forEach(householdIncomeKeys, (key, index) => {
    enums[key] = index + 1;
  });

  return enums;
};

const realHouseholdIncome = _.invert(buildHouseholdIncomeEnums());

export const formatString = (value) => value.replaceAll(/\s|"|]|!|\[/g, '');

export const getPaginatedTesters = async (params) => {
  let rows = [];
  try {
    const { users, usersCount } = await getTesters(params);
    const householdIncomeEnum = buildHouseholdIncomeEnums();

    const replaceHouseholdIncome = (value) => householdIncomeEnum[value || '-'] || 0;

    if (users) {
      rows = users.map((user) => {
        const {
          averageRating,
          email,
          guest,
          id,
          lastEmailed,
          lastInvite,
          lastLogin,
          lastParticipated,
          profile,
          status,
          testsTakenNumber,
          isBannedModeratedAt,
        } = user;

        return {
          id,
          firstName: profile?.firstName,
          lastName: profile?.lastName,
          guestTester: guest ? 'yes' : 'no',
          status: _.upperFirst(_.first(_.split(status, '_', 2))),
          gender: profile?.gender || '-',
          ethnicity: (profile?.raceEthnicHeritage) || '-',
          householdIncome: replaceHouseholdIncome(profile?.annualHouseholdIncome),
          country: (profile?.country) || '-',
          state: (!_.isEmpty(profile?.country) && profile?.country === 'us' && profile?.state) || '-',
          zipcode: (profile?.zipcode) || '-',
          paypalAddress: (profile?.paypalAccount) || '-',
          age: profile?.birthdate ? moment().diff(profile?.birthdate, 'years') : 0,
          email,
          computer: profile?.computer ? joinArrayItems(profile?.computer) : '-',
          tablet: profile?.tablet ? joinArrayItems(profile?.tablet) : '-',
          phone: profile?.smartphone ? joinArrayItems(profile?.smartphone) : '-',
          phoneNumber: '-',
          lastParticipated: lastParticipated ? moment(lastParticipated).format('MM/DD/YYYY hh:mm A') : '-',
          lastInvited: lastInvite ? moment(lastInvite).format('MM/DD/YYYY hh:mm A') : '-',
          lastEmailed: lastEmailed ? moment(lastEmailed).format('MM/DD/YYYY hh:mm A') : '-',
          lastApplied: '-',
          lastLoggedIn: lastLogin ? moment(lastLogin).format('MM/DD/YYYY hh:mm A') : '-',
          jobTitle: (!_.isEmpty(profile?.currentPosition) && profile?.currentPosition.title)
            || (profile?.linkedinFields && profile?.linkedinFields.currentPosition
            && profile?.linkedinFields.currentPosition.title) || '-',
          jobRole: (!_.isEmpty(profile?.jobCategories) && profile?.jobCategories.map(
            (job) => job.name,
          )) || '-',
          currentWorkStatus: profile?.workStatus ? joinArrayItems(profile?.workStatus) : '-',
          education: profile?.educationLevel
            || (profile?.linkedinFields && profile?.linkedinFields.educationLevel) || '-',
          companySize: (profile?.currentPosition && profile?.currentPosition.company && profile?.currentPosition.company.size)
            || (profile?.linkedinFields && profile?.linkedinFields.currentPosition
            && profile?.linkedinFields.currentPosition.company && profile?.linkedinFields.currentPosition.company.size) || '-',
          industry: (profile?.currentPosition && profile?.currentPosition.company && profile?.currentPosition.company.industry)
            || (profile?.linkedinFields && profile?.linkedinFields.currentPosition
            && profile?.linkedinFields.currentPosition.company
            && profile?.linkedinFields.currentPosition.company.industry) || '-',
          seniority: (profile?.currentPosition && profile?.currentPosition.seniority)
            || (profile?.linkedinFields && profile?.linkedinFields.currentPosition
            && profile?.linkedinFields.currentPosition.seniority) || '-',
          rating: averageRating || 0,
          language: profile?.languages ? joinArrayItems(profile?.languages) : '-',
          testTaken: testsTakenNumber,
          isBannedModeratedAt: !!isBannedModeratedAt, // change to boolean, it doesnt matter
        };
      });
    }

    return {
      records: rows,
      totalRecords: usersCount,
    };
  } catch (error) {
    throw new Error(error);
  }
};

export const ActionRenderer = (params) => {
  const history = useHistory();

  if (params.value) {
    return (
      <>
        <Icon
          name="user"
          onClick={() => {
            history.push(`/tester/${params.data.id}`);
          }}
        />
        {params.value}
      </>
    );
  }
  return (
    <>
      loading...
    </>
  );
};

export const numberActionRenderer = (params) => {
  if (params.value) {
    return params.value;
  }

  return '-';
};

export const householdIncomeActionRenderer = ({ value }) => realHouseholdIncome[value] || '-';

export const keysFilters = {
  firstName: '',
  lastName: '',
  guestTester: '',
  gender: '',
  ethnicity: '',
  householdIncome: '',
  country: '',
  zipcode: '',
  paypalAddress: '',
  age: '',
  email: '',
  computer: '',
  tablet: '',
  phone: '',
  phoneNumber: '',
  language: '',
  lastParticipated: '',
  lastInvited: '',
  lastApplied: '',
  lastLoggedIn: '',
  jobTitle: '',
  jobRole: '',
  currentWorkStatus: '',
  education: '',
  companySize: '',
  industry: '',
  seniority: '',
  rating: '',
  testTaken: '',
  status: '',
};
